import {
  FINANCE_ROUNDING_EFFECTIVE_RATE_DECIMAL_PLACES,
  FINANCE_ROUNDING_TOTAL_DECIMAL_PLACES,
} from './rounding.constants';

export const FINANCE_LINE_DESCRIPTION_MAX_LENGTH = 500;
export const FINANCE_QUANTITY_MAX_DECIMAL_PLACES = 2;

const createUnsignedDecimalPattern = (maxDecimalPlaces: number): RegExp =>
  new RegExp(`^\\d+(\\.\\d{1,${maxDecimalPlaces}})?$`);

const createSignedDecimalPattern = (maxDecimalPlaces: number): RegExp =>
  new RegExp(`^-?\\d+(\\.\\d{1,${maxDecimalPlaces}})?$`);

export const FINANCE_QUANTITY_PATTERN = createUnsignedDecimalPattern(
  FINANCE_QUANTITY_MAX_DECIMAL_PLACES
);
export const FINANCE_UNIT_PRICE_PATTERN = createUnsignedDecimalPattern(
  FINANCE_ROUNDING_EFFECTIVE_RATE_DECIMAL_PLACES
);
export const FINANCE_SIGNED_UNIT_PRICE_PATTERN = createSignedDecimalPattern(
  FINANCE_ROUNDING_EFFECTIVE_RATE_DECIMAL_PLACES
);
export const FINANCE_AMOUNT_PATTERN = createSignedDecimalPattern(
  FINANCE_ROUNDING_TOTAL_DECIMAL_PLACES
);
